import { Injectable } from "@angular/core";

@Injectable()
export class ObjectsService {
    
userGender:any;
userName:any;
userFirstname:any;
userEmail:any;
userPhone:any;
userMobile:any;
societySocialReason:any;
societyAddress: any;
societyPostalCode:any;
societyCity:any;
societyCountry:any;

customerName:any;
customerFirstname:any;
customerMail:any;
customerPhone:any;
customerMobile:any;
customerGender:any;

billingSocialReason:any;
billingAddress:any;
billingPostalCode:any;
billingCity:any;
billingCountry:any;
billingSiretNum:any;
billingTvaNum:any;

  constructor() {}

  User(userGender: any, userName: any, userFirstname: any, userEmail: any, userPhone: any, userMobile: any, societySocialReason: any, societyAddress: any, societyPostalCode: any, societyCity: any, societyCountry: any){
        this.userGender = userGender;
        this.userName = userName;
        this.userFirstname = userFirstname;
        this.userEmail = userEmail;
        this.userPhone = userPhone;
        this.userMobile = userMobile;
        this.societySocialReason = societySocialReason;
        this.societyAddress = societyAddress;
        this.societyPostalCode = societyPostalCode;
        this.societyCity = societyCity;
        this.societyCountry = societyCountry;
  }

  Customer(customerName: any, customerFirstname: any, customerMail: any, customerPhone: any, customerMobile: any, customerGender: any){
        this.customerName = customerName;
        this.customerFirstname = customerFirstname;
        this.customerMail = customerMail;
        this.customerPhone = customerPhone;
        this.customerMobile = customerMobile;
        this.customerGender = customerGender;
  } 

  Billing(billingSocialReason: any, billingAddress: any, billingPostalCode: any, billingCity: any, billingCountry: any, billingSiretNum: any, billingTvaNum: any){
        this.billingSocialReason = billingSocialReason;
        this.billingAddress = billingAddress;
        this.billingPostalCode = billingPostalCode;
        this.billingCity = billingCity;
        this.billingCountry = billingCountry;
        this.billingSiretNum = billingSiretNum;
        this.billingTvaNum = billingTvaNum;
    }
}
